module.exports = __webpack_public_path__ + "media/alarm.f721e326.wav";